<template>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <h3>Surat Peringatan</h3>
                <div class="font-medium text-500 mb-3">
                    Rincian Surat Peringatan
                </div>
                <div v-if="isEdit" class="field grid">
                    <label
                        for="name3"
                        class="col-12 mb-2 md:col-3 md:mb-0 font-medium"
                        >No Surat</label
                    >
                    <InputText
                        id="is_present"
                        v-model="form.letter_no"
                        name="is_present"
                    />
                </div>
                <div class="field grid">
					<label for="name3" class="col-12 mb-2 md:col-3 md:mb-0 font-medium">{{ $t('start-date') }}</label>
                        <Calendar :showIcon="true"
                        :showButtonBar="true"
                        :class="{'p-invalid' : submitted && !form.start_of_warning }"
                        v-model="form.start_of_warning"
                        dateFormat="yy-mm-dd" />
                        <small class="p-invalid" v-if="submitted && !form.start_of_warning"
                            >{{ $t('start-date') }} is required.</small
                        >
                    <div class="col-12 mt-1 md:col-2 font-medium">
                        <label for="name3">{{ $t('end-date') }}</label>
                    </div>
                        <Calendar :showIcon="true"
                        :showButtonBar="true"
                        :class="{'p-invalid' : submitted && !form.end_of_warning }"
                        v-model="form.end_of_warning"
                        dateFormat="yy-mm-dd" />
                        <small class="p-invalid" v-if="submitted && !form.end_of_warning"
                            >{{ $t('end-date') }} is required.</small
                        >
				</div>
                <div class="field grid">
                    <label
                        for="name3"
                        class="col-12 mb-2 md:col-3 md:mb-0 font-medium"
                        >Peringkatan Ke</label
                    >
                    <Dropdown
                    :class="{ 'p-invalid': submitted && !form.warning_number }"
                    v-model="form.warning_number"
                    :options="warningNumbers"
                    placeholder="Select Warning Number"
                    required="true"
                    />
                    <small class="p-invalid" v-if="submitted && !form.warning_number">
                        Peringatan Ke is required.
                    </small>
                </div>
                <div class="field grid">
                    <label
                        for="name3"
                        class="col-12 mb-2 md:col-3 md:mb-0 font-medium"
                        >Nama Karyawan</label
                    >
                    <AutoComplete
                        forceSelection
                        placeholder="Search"
                        id="dd"
                        :dropdown="true"
                        v-model="selectedEmployee"
                        :suggestions="autoFilteredValue"
                        @complete="searchEmployee($event)"
                        @item-select="selectApprovedBy"
                        field="name"
                        :class="{
                            'p-invalid': submitted && !selectedEmployee,
                        }"
                    />
                    <small
                        class="p-invalid"
                        v-if="submitted && !selectedEmployee"
                    >
                        Created By is required.
                    </small>
                </div>
                <div class="field grid">
                    <label
                        for="name3"
                        class="col-12 mb-2 md:col-3 md:mb-0 font-medium"
                        >Penempatan</label
                    >
                    <Dropdown
                        v-model="form.placement_id"
                        :options="placements"
                        optionLabel="name"
                        optionValue="id"
                        placeholder="Select Placement"
                    />
                </div>
                <div class="field grid">
                    <label for="name" class="col-12 mb-2 md:col-3 md:mb-0 font-medium">Daftar Kesalahan</label>
                    <ckeditor
                        id="mistakes"
                        required="true"
                        :editor="editor"
                        v-model="form.mistakes"
                        :config="editorConfig"
                        :autoResize="true"
                        :class="{ 'p-invalid' : submitted && !form.mistakes }">
                    </ckeditor>
                    <small class="p-invalid" v-if="submitted && !form.mistakes"
                        >Mistakes is required.</small
                    >
                </div>
                <div class="field grid">
                    <label
                        for="name3"
                        class="col-12 mb-2 md:col-3 md:mb-0 font-medium"
                        >PIC</label
                    >
                    <AutoComplete
                        forceSelection
                        placeholder="Search"
                        id="dd"
                        :dropdown="true"
                        v-model="selectedPic"
                        :suggestions="autoFilteredValue"
                        @complete="searchEmployee($event)"
                        @item-select="selectPicId"
                        field="name"
                        :class="{ 'p-invalid': submitted && !selectedPic }"
                    />
                    <small class="p-invalid" v-if="submitted && !selectedPic">
                        PIC is required.
                    </small>
                </div>
                <Button
                    :loading="isSaving"
                    @click="save"
                    id="button1"
                    label="Save"
                />
            </div>
        </div>
    </div>
</template>
<script>
import AppLayoutVue from "../../../Layouts/AppLayout.vue";
import AutoComplete from "primevue/autocomplete";
import Button from "primevue/button";
import Calendar from "primevue/calendar";
import Checkbox from "primevue/checkbox";
import Dropdown from "primevue/dropdown";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import Textarea from "primevue/textarea";
import axios from "axios";
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';


export default {
    layout: AppLayoutVue,
    components: {
        AutoComplete,
        Button,
        Calendar,
        Checkbox,
        Dropdown,
        InputText,
        InputNumber,
        Textarea,
        ckeditor: CKEditor.component,
    },
    data() {
        return {
            form: this.$page.props.warning ?? {
                mistakes :
                    "<ol><li>Tidak masuk kerja dan tidak ada Surat Keterangan Dokter pada Hari Rabu</li></ol>",
            },
            placements: {},
            positions: {},
            warningNumbers: [1, 2, 3],
            submitted: false,
            autoFilteredValue: [],
            selectedEmployee: this.$page.props.warning
                ? this.$page.props.warning.employee
                : "",
            selectedPic: this.$page.props.warning
                ? this.$page.props.warning.pic
                : "",
            isEdit: this.$page.props.warning ? true : false,
            isSaving: false,
            editor: ClassicEditor,
            editorConfig: {
                // The configuration of CKEditor
            },
        };
    },
    computed: {
        totalFee() {
            return (this.form.amount * 8.5) / 100;
        },
    },
    mounted() {
        this.initData();
    },
    methods: {
        searchEmployee(event) {
            setTimeout(() => {
                if (!event.query.trim().length) {
                    axios
                        .get(`${this.$page.props.appUrl}api/employees`)
                        .then((data) => {
                            this.autoFilteredValue = data.data.data;
                        });
                } else {
                    let filterValue = event.query.toLowerCase();
                    axios
                        .get(
                            `${this.$page.props.appUrl}api/employees?search=${filterValue}`
                        )
                        .then((data) => {
                            this.autoFilteredValue = data.data.data;
                        });
                }
            }, 250);
        },
        selectApprovedBy() {
            axios
                .get(
                    `${this.$page.props.appUrl}api/employees/${this.selectedEmployee.id}`
                )
                .then((data) => {
                    this.form.employee_id = this.selectedEmployee.id;
                });
        },
        selectPicId() {
            axios
                .get(
                    `${this.$page.props.appUrl}api/employees/${this.selectedPic.id}`
                )
                .then((data) => {
                    this.form.pic_id = this.selectedPic.id;
                });
        },
        initData() {
            axios
                .get(`${this.$page.props.appUrl}api/placement-units`)
                .then((data) => {
                    this.placements = data.data;
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Can't Get Data Placement, Refresh Again in 5 second. If still not shown contact support",
                        life: 3000,
                    });
                });
            axios
                .get(`${this.$page.props.appUrl}api/positions`)
                .then((data) => {
                    this.positions = data.data;
                });
        },
        clearForm() {
            this.form = {
                mistakes:
                    "Pembayaran Tagihan Tenaga Security Sebanyak xx orang (Anggota) Periode :xx - xx November 2022",
            };
            this.selectedEmployee = "";
        },
        save() {
            this.isSaving = true;
            this.submitted = true;

            if (this.isEdit) {
                axios
                    .put(
                        `${this.$page.props.appUrl}api/letters/warnings/${this.$page.props.warning.id}`,
                        this.form
                    )
                    .then((data) => {
                        this.clearForm();
                        this.submitted = false;

                        this.$toast.add({
                            severity: "success",
                            summary: "Successful",
                            detail: "Warning Updated",
                            life: 3000,
                        });
                    })
                    .catch((error) => {
                        this.$toast.add({
                            severity: "error",
                            summary: "Error When Updating Warning",
                            detail: error,
                            life: 3000,
                        });
                    });
            } else {
                axios
                    .post(`${this.$page.props.appUrl}api/letters/warnings`, this.form)
                    .then((data) => {
                        this.clearForm();
                        this.submitted = false;

                        this.$toast.add({
                            severity: "success",
                            summary: "Successful",
                            detail: "Warning Created",
                            life: 3000,
                        });
                    })
                    .catch((error) => {
                        this.$toast.add({
                            severity: "error",
                            summary: "Error When Creating Warning",
                            detail: error,
                            life: 3000,
                        });
                    });
            }

            this.isSaving = false;
        },
    },
};
</script>
